/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SsoSignup
 */
export interface SsoSignup {
    /**
     * 
     * @type {string}
     * @memberof SsoSignup
     */
    buttonTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof SsoSignup
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SsoSignup
     */
    icon?: string;
}

export function SsoSignupFromJSON(json: any): SsoSignup {
    return {
        'buttonTitle': !exists(json, 'buttonTitle') ? undefined : json['buttonTitle'],
        'redirectUrl': json['redirectUrl'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
    };
}

export function SsoSignupToJSON(value?: SsoSignup): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'buttonTitle': value.buttonTitle,
        'redirectUrl': value.redirectUrl,
        'icon': value.icon,
    };
}


